import React, {useReducer} from 'react'
import {makeStyles, TableCell, TableRow} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import moment from "moment";
import WorkableIconDownloadButton from 'components/button/WorkableIconDownloadButton';
import DateFormats from "constants/DateFormats";
import iconWorksReducer from "libs/iconWorksReducer";
import WorkableIconSearchButton from "components/button/WorkableIconSearchButton";
import DemandOffersGeneralInfoService from "services/DemandOffersGeneralInfoService";
import WorkableIconForwardButton from "components/button/WorkableIconForwardButton";

const useStyle = makeStyles(theme => ({
    warnIcon: {
        padding: 0,
        color: `${theme.palette.secondary.main} !important`
    },
    descriptionTooltip: {
        whiteSpace: 'pre-line'
    },
    buttonColumn: theme.components.table.buttonColumn,
    versionsCell: {
        background: theme.palette.background.default,
        paddingLeft: 0,
        paddingRight: 0
    }
}));

function GeneralInfoDocumentsFileTableRow(
    {
        demandId,
        stageId,
        supplierId,
        index,
        row,
        onEditDescriptionFile,

    }) {
    const classes = useStyle();

    const [iconWorks, dispatchIconWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        download: false,
        goto: false
    });

    const onDownload = () => {
        dispatchIconWorks({type: "download", works: true});
        DemandOffersGeneralInfoService.getDownloadFile(demandId, stageId, row.source, row.identity, supplierId)
            .finally(() => dispatchIconWorks({type: 'download', works: false}));
    }


    return (
        <>
            <TableRow>
                <TableCell>{index}</TableCell>
                <TableCell>
                    {row.name}
                </TableCell>
                <TableCell className={classes.buttonColumn}>
                    <WorkableIconSearchButton
                        onClick={() => onEditDescriptionFile(row)}
                        tooltip={row.description ? <p className={classes.descriptionTooltip}>{row.description}</p> : <i>{Tr('no_description')}</i>}
                    />
                </TableCell>
                <TableCell>{row.publishDate ? moment(row.publishDate).format(DateFormats.DATETIME_FORMAT) : null}</TableCell>
                <TableCell className={classes.buttonColumn}>
                    {
                        !!row.actions.goto &&
                        <WorkableIconForwardButton
                            onClick={()=>{
                                dispatchIconWorks({type: "download", works: true});
                                window.location.href = row.actions.goto.url
                            }
                            }
                            tooltip={Tr('go')}
                            disabled={iconWorks.anyWorks}
                            working={iconWorks.goto}/>
                    }
                    {
                        !!row.actions.download &&
                        <WorkableIconDownloadButton
                                onClick={() => onDownload(row)}
                                hideTooltip={!row.actions.download}
                                disabled={iconWorks.anyWorks}
                                working={iconWorks.download}
                            />
                    }
                </TableCell>
            </TableRow>

        </>
    )
}

GeneralInfoDocumentsFileTableRow.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    stageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    row: PropTypes.shape({
        identity: PropTypes.number.isRequired,
        source: PropTypes.string.isRequired
    }).isRequired,
    index: PropTypes.number.isRequired,
    onEditDescriptionFile: PropTypes.func.isRequired
};

export default GeneralInfoDocumentsFileTableRow;